import { PlusCircleFilled } from "@ant-design/icons";
import {
  ArrowRight,
  Assignment,
  Delete,
  Edit,
  MoreVert,
  Save,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import CustomTextField from "components/CustomTextField";
import GovernNav from "components/Government/GovernNav";
import HclDashNav from "components/HclDashNav";
import { selectCurrentRoles, selectCurrentUser } from "features/auth/authSlice";
import { useGetmasterRolesQuery } from "features/masterdata/MasterApiSlice";
import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import {
  useGetBlockBysubDstrictQuery,
  useGetDistrictByStateQuery,
  useGetStatesQuery,
  useGetSubDistrictQuery,
} from "services/locationApiSlice";
import swal from "sweetalert";
import AddProjectModal from "./AddProject/AddProjectModal";
import EditProject from "./AddProject/EditProject";
import ReportingtoId from "./ReportingtoId";
import {
  useAddEmployeeMutation,
  useGetEmployeeByIdQuery,
  useUpdateEmployeeMutation,
} from "./UserManagementApiSlice";

const AddEmployee = ({
  isCreateComponent = false,
  cancelbutton,
  setPopUpAddEmployee,
  refetch,
}) => {
  const emp_id = useParams("id").id;

  const RolesFromToken = useSelector(selectCurrentRoles);
  const [isEditable, setIsEditable] = useState(isCreateComponent);
  const [addreporting, setAddReporting] = useState(isCreateComponent);
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [subDistrictId, setsubDistrictId] = useState("");
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [SubDistrictList, setSubDistrictList] = useState([]);
  const [rolesList, setCheckRolesList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [blockId, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [subDistrictName, setsubDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [zone, setZone] = useState("");
  const [designation, setDesignation] = useState("");
  const [domain, setDomain] = useState([]);
  const [addModel, setAddModel] = useState(false);
  const [ProfileModel, setProfileModel] = useState(false);
  const [activeValue, setActiveValue] = useState(true);
  const [submitDisableButton, setButtonDisable] = useState(false);
  const [roles, setRoles] = useState([]);
  const [rolesId, setRolesId] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [assignedZoneCodes, setAssignedZoneCodes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [employeeData, setEmployeeData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    DOB: "",
    department: "",
    employee_code: "",
    designation: "",
    roles: "",
    rolesId: "",
    assigned_zone: "",
    assigned_domains: "",
    assigned_zone_codes: "",
    assigned_projects: "",
    assigned_zone_code_names: "",
  });

  const [assignedProjects, setAssignedProjects] = useState([]);

  const [phoneEnable, setPhoneEnable] = useState(false);
  const [addProject, setAddProject] = useState(false);
  const [editProjectModal, setEditProjectModal] = useState(false);
  const { data: getRoles } = useGetmasterRolesQuery();
  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId);
  const { data: dataSubDistrict } = useGetSubDistrictQuery(stateId, districtId);
  const { data: dataBlock } = useGetBlockBysubDstrictQuery(subDistrictId);
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  // console.log("RoleAcessParams",currentUser)
  const [AddEmployee] = useAddEmployeeMutation();

  const {
    data: employeeDataFromApi,
    isLoading,
    refetch: employeeDataRefetch,
  } = useGetEmployeeByIdQuery(emp_id);

  const [updateEmployee] = useUpdateEmployeeMutation(emp_id);
  const [opendeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState({});
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event, project) => {
    setAnchorEl(event.currentTarget);
    setSelectedProject(project);
  };

  // Close menu
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = (projectId) => {
    setSelectedProjectId(projectId);
    setOpenDeleteModal(true);
  };

  const handleDelete = () => {
    updateEmployee({
      id: emp_id,
      payload: {
        assigned_project: assignedProjects.filter(
          (project) => project.id != selectedProjectId
        ),
      },
    })
      .unwrap()
      .then((data) => {
        if (data?.success == true) {
          swal("Employee Data Updated Successfully", {
            buttons: false,
            icon: "success",
            title: "Data Updated ",
            timer: 1500,
          });
          setAnchorEl(null);
          employeeDataRefetch();
        } else {
          swal("Missing Fields", {
            buttons: false,
            icon: "warning",
            title: "Please fill Full Details",
            timer: 1500,
          });
        }
      })
      .catch((e) => {
        swal("Missing Fields", {
          buttons: false,
          icon: "warning",
          title: "Please fill Full Details",
          timer: 3000,
        });
      });

    setSelectedProjectId(null);
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    setEmployeeData({ ...employeeDataFromApi?.data });
    setDesignation(employeeDataFromApi?.data?.designation);
    if (emp_id) {
      setPhoneEnable(true);
    }
    setAssignedProjects(employeeDataFromApi?.data?.assigned_project || []);
    setZone(employeeDataFromApi?.data?.assigned_zone || "");
    setAssignedZoneCodes(employeeDataFromApi?.data?.assigned_zone_codes || []);
    setSelectedZones(employeeDataFromApi?.data?.assigned_zone_code_names || []);
  }, [employeeDataFromApi]);

  const handleRolesOptions = () => {
    let responseAgentArray = [];
    const filteredList = rolesList.filter((item) => {
      if (RolesFromToken?.groups?.includes("admin")) {
        return item.name !== "admin";
      }
      if (RolesFromToken?.groups?.includes("developer")) {
        return true;
      }
      if (RolesFromToken?.groups?.includes("HR")) {
        return [
          "State Head",
          "District Head",
          "Cluster Head",
          "Maker",
          "Checker",
          "FLE",
        ].includes(item.name);
      }
       if (RolesFromToken?.groups?.includes("Banking Admin")) {
        return [
          "State Head",
          "District Head",
          "Cluster Head",
          "Maker",
          "Checker",
          "FLE",
        ].includes(item.name);
      }
      if (RolesFromToken?.groups?.includes("State Head")) {
        return [
          "District Head",
          "Cluster Head",
          "Maker",
          "Checker",
          "FLE",
        ].includes(item.name);
      }
      if (
        RolesFromToken?.groups?.includes("District Head") ||
        RolesFromToken?.groups?.includes("Cluster Head")
      ) {
        return ["FLE"].includes(item.name);
      }
      if (RolesFromToken?.groups?.includes("CRM Admin")) {
        return ["CRM User"].includes(item.name);
      }

      if (RolesFromToken?.groups?.includes("Maker")) {
        return false;
      }
      if (RolesFromToken?.groups?.includes("Checker")) {
        return false;
      }
      if (RolesFromToken?.groups?.includes("CRM User")) {
        return false;
      }
      return false;
    });

    filteredList?.map((item) => {
      responseAgentArray.push({
        value: item.id,
        label: item.name,
      });
    });

    return responseAgentArray;
  };

  const handleRole = (event) => {
    const values = event?.map((item) => {
      return item.value;
    });
    const labels = event?.map((item) => {
      return item.label;
    });
    setRoles(labels);
    setRolesId(values);
  };

  const handleSingleRole = (event) => {
    setRoles(event.label);
    setRolesId(event.value);
  };
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });

    return responseAgentArray;
  };

  const handleSubDistrictOptions = () => {
    let responseAgentArray = [];
    SubDistrictList.map((sub_district) => {
      responseAgentArray.push({
        value: sub_district.sub_district_code,
        label: sub_district.sub_district_name,
        ConditionName: "Sub_district",
      });
    });
    return responseAgentArray;
  };
  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };

  const onDistrictChange = (event) => {
    if (zone === "District") {
      const values = event?.map((item) => {
        return item.value;
      });
      const labels = event?.map((item) => {
        return item.label;
      });
      setSelectedZones(labels);
      setAssignedZoneCodes(values);
    } else {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
  };

  const onSubDistrictChange = (event) => {
    if (zone === "SubDistrict") {
      const values = event?.map((item) => {
        return item.value;
      });
      const labels = event?.map((item) => {
        return item.label;
      });
      setSelectedZones(labels);
      setAssignedZoneCodes(values);
    } else {
      setsubDistrictId(event.value);
      setsubDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
  };
  const onBlockChange = (event) => {
    if (zone === "Block") {
      const values = event?.map((item) => {
        return item.value;
      });
      const labels = event?.map((item) => {
        return item.label;
      });
      setSelectedZones(labels);
      setAssignedZoneCodes(values);
    } else {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };

  const onLocationChange = (event) => {
    if (zone === "State") {
      const values = event?.map((item) => {
        return item.value;
      });
      const labels = event?.map((item) => {
        return item.label;
      });
      setSelectedZones(labels);
      setAssignedZoneCodes(values);
    } else {
      setStateId(event.value);
      setStateName(event.label);
    }
  };

  useEffect(() => {
    if (getRoles !== undefined) {
      setCheckRolesList(getRoles?.data);
    }
  }, [getRoles]);

  useEffect(() => {
    if (getStates !== undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);

  useEffect(() => {
    if (dataDistrict !== undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock !== undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);

  useEffect(() => {
    if (dataSubDistrict !== undefined) {
      setSubDistrictList(dataSubDistrict?.data?.results);
    }
  }, [dataSubDistrict]);

  const customStyles = {
    control: (base) => ({
      ...base,
      // height: 50,
      minHeight: 40,
    }),
  };

  const handleInputChange = (event) => {
    // console.log(event.target.name, "event");

    setEmployeeData({
      ...employeeData,
      [event.target.name]: event.target.value,
    });
  };

  const ZoneOptions = [
    { value: "State", label: "State" },
    { value: "District", label: "District" },
    { value: "Sub-District", label: "Sub-District" },
    { value: "Block", label: "Block" },
  ];

  const designationOptions = [
    { value: "Developer", label: "Developer" },
    { value: "Field Staff", label: " Field Staff" },
    { value: "Research", label: "Research" },
    { value: "HR", label: "HR" },
    { value: "Remote Sensing", label: "Remote Sensing" },
  ];

  const DomainOptions = [
    { value: "Banking", label: "Banking" },
    { value: "Insurance", label: "Insurance" },
    { value: "Survey", label: "Survey" },
    { value: "CRM", label: "CRM" },
    { value: "Procurement", label: "Procurement" },
  ];

  const handleZone = (e) => {
    setZone(e.value);
  };

  const handleDesignation = (e) => {
    setDesignation(e.target.value);
  };

  const handleDomain = (e) => {
    const domains = e.map((item) => {
      return item.value;
    });
    setDomain(domains);
  };

  useEffect(() => {
    if (employeeData?.roles) {
      setRoles(employeeData.roles);
    }
    setActiveValue(employeeData?.is_active);
  }, [employeeData]);


  const handleEnabledButton = () => {
    let sendData = {
      is_active: !activeValue,
    };
    updateEmployee({ id: emp_id, payload: sendData })
      .unwrap()
      .then((data) => {
        if (data?.data?.is_active == true) {
          swal("Data Updated", {
            buttons: false,
            icon: "success",
            title: " Successfully Enabled",
            timer: 1500,
          });
          employeeDataRefetch();
          setProfileModel(false);
        } else if (data?.data?.is_active == false) {
          swal("Data Updated", {
            buttons: false,
            icon: "success",
            title: "Successfully Disabled",
            timer: 1500,
          });
          employeeDataRefetch();
          setProfileModel(false);
        }
      })
      .catch((e) => {
        swal("!!", {
          buttons: false,
          icon: "warning",
          title: "Something Went wrong",
          timer: 3000,
        });
      });
  };

  const handleProjectSubmit = () => {
    setIsSubmitting(true);

    updateEmployee({
      id: emp_id,
      payload: {
        assigned_project: assignedProjects.map((p) => {
          if (p.id === selectedProject.id) {
            return selectedProject;
          }
          return p;
        }),
      },
    })
      .unwrap()
      .then((data) => {
        if (data?.success) {
          swal("Employee Data Updated Successfully", {
            buttons: false,
            icon: "success",
            title: "Data Updated",
            timer: 1500,
          });
          employeeDataRefetch();
        } else {
          swal("Missing Fields", {
            buttons: false,
            icon: "warning",
            title: "Please fill Full Details",
            timer: 1500,
          });
        }
      })
      .catch((e) => {
        console.error("Update Error:", e);
        swal("Error occurred", {
          buttons: false,
          icon: "error",
          title: "Something went wrong",
          timer: 3000,
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  // console.log("assigned zone codes ", assignedZoneCodes);
  const handleSubmitButton = () => {
    const assignedDomains =
      domain.length > 0 ? domain : employeeData.assigned_domains;
    const assignedZoneCodes_ =
      assignedZoneCodes.length > 0
        ? assignedZoneCodes
        : employeeData.assigned_zone_codes;
    const assignedZones = zone.length > 0 ? zone : employeeData.assigned_zone;
    const staticZoneCode = ["9"];
    const staticZoneDomain = ["CRM"];

    let sendData = {
      first_name: employeeData?.first_name,
      last_name: employeeData?.last_name,
      phone_number: employeeData.phone_number,
      email: employeeData.email,
      DOB:
        employeeData?.DOB?.split("-")[0].length == 4
          ? employeeData?.DOB?.split("-")
              .reverse()
              .join("-")
          : employeeData?.DOB,
      department: employeeData.department,
      employee_code: employeeData.employee_code,
      designation: designation || employeeData.designation,
      assigned_zone:
        roles.includes("CRM Admin") || roles.includes("CRM User")
          ? "State"
          : assignedZones,
      assigned_zone_codes:
        roles.includes("CRM Admin") || roles.includes("CRM User")
          ? staticZoneCode
          : assignedZoneCodes_,
      assigned_domains:
        RolesFromToken?.groups?.includes("Banking Admin")?"Banking":
        roles.includes("CRM Admin") || roles.includes("CRM User")
          ? staticZoneDomain
          : RoleAcessParams.includes("FPO") || RoleAcessParams.includes("CBBO")
          ? ["Enrollment"]
          : assignedDomains,
    };

    if (rolesId.length > 0) {
      sendData["roles"] = rolesId;
    }
    setButtonDisable(true);

    if (isCreateComponent) {
      AddEmployee(sendData)
        .unwrap()
        .then((data) => {
          if (data.success == true) {
            swal("Employee Added Successfully", {
              buttons: false,
              icon: "success",
              title: "Employee Added detail",
              timer: 1500,
            });
            setZone("");
            employeeDataRefetch();
            cancelbutton(false);
            setButtonDisable(false);
            refetch();
            setPopUpAddEmployee(false);
          }
        })

        .catch((data) => {
          // console.log(data.data.error, "line 152");
          if (data.data.error.code == 400) {
            swal("All Fields are mandatory", {
              buttons: false,
              icon: "warning",
              title: "Please fill full Details",
              timer: 1500,
            });
            setButtonDisable(false);

            return;
          } else if (data.data.error.code == 409) {
            swal("!!", {
              buttons: false,
              icon: "warning",
              title: data.data.error.message,
              timer: 2000,
            });
            setButtonDisable(false);
          }
        });
    } else if (!isCreateComponent) {
      updateEmployee({ id: emp_id, payload: sendData })
        .unwrap()
        .then((data) => {
          if (data?.success == true) {
            swal("Employee Data Updated Successfully", {
              buttons: false,
              icon: "success",
              title: "Data Updated ",
              timer: 1500,
            });
            setZone("");
            setIsEditable(false);
            employeeDataRefetch();
            setProfileModel(false);
            setButtonDisable(false);
          } else {
            swal("Missing Fields", {
              buttons: false,
              icon: "warning",
              title: "Please fill Full Details",
              timer: 1500,
            });
            setButtonDisable(false);
          }
          //   setTimeout(function(){
          //     window.location.reload();
          //  }, 2500);
        })
        .catch((e) => {
          swal("Missing Fields", {
            buttons: false,
            icon: "warning",
            title: "Please fill Full Details",
            timer: 3000,
          });
          setButtonDisable(false);
        });
    }
  };

  const handleEditButton = (clear) => {
    setPhoneEnable(true);
    setIsEditable(!isEditable);
    if (clear) {
      employeeDataRefetch();
      setEmployeeData({ ...employeeDataFromApi?.data });
      setZone("");
    }
  };

  const handleAddModel = () => {
    setAddModel(true);
  };
  const handleClose = () => {
    setAddModel(false);
    setProfileModel(false);
  };

  const handleSwitchProfile = () => {
    setProfileModel(true);
  };

  const handleAddProjects = () => {
    setAddProject(true);
  };
  const handleEditProject = () => {
    handleMenuClose();
    setEditProjectModal(true);
  };
  const handleCloseProjectModal = () => {
    setAddProject(false);
    localStorage.removeItem("selectedCbbo");
    localStorage.removeItem("selectedFpo");
  };

  const options = handleRolesOptions();

  const selectedRoles = options.filter((option) =>
    employeeData?.roles?.includes(option.label)
  );
  const selectedDomain = DomainOptions?.filter((option) =>
    employeeData?.assigned_domains?.includes(option.label)
  );
  // console.log("selectedDomain",selectedDomain)
  const availableDomains = [DomainOptions?.find(opt =>
  (employeeData?.assigned_domains ?? []).includes(opt.label)
)].filter(Boolean);  

// console.log("availableDomains",availableDomains)


  return (
    <>
      {RoleAcessParams.includes("HCL") ? (
        <HclDashNav />
      ) : RoleAcessParams.includes("UP_GOV") ? (
        <GovernNav />
      ) : (
        ""
      )}

      <div
        className={
          RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV")
            ? "container-fluid mt-4"
            : ""
        }
        style={{
          paddingLeft:
            RoleAcessParams.includes("HCL") ||
            RoleAcessParams.includes("UP_GOV")
              ? "6rem"
              : "",
          paddingRight:
            RoleAcessParams.includes("HCL") ||
            RoleAcessParams.includes("UP_GOV")
              ? "6rem"
              : "",
        }}
      >
        {!isCreateComponent ? (
          <Row>
            {!isLoading ? (
              <Col lg="4">
                <Card className="position-relative">
                  <div className="d-flex justify-content-between w-100 px-2  position-absolute">
                    <h5
                      className={
                        employeeData?.is_active
                          ? "text-success p-1"
                          : "text-secondary p-1"
                      }
                    >
                      {employeeData?.is_active ? "Enabled" : "Disabled"}{" "}
                    </h5>
                    <Switch
                      size="small"
                      color="success"
                      checked={employeeData?.is_active ? true : false}
                      onChange={handleSwitchProfile}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                  <CardBody
                    className="d-flex justify-content-center align-items-center "
                    style={{ padding: "1.2rem", minHeight: "150px" }}
                  >
                    <Col lg="4" className="">
                      <img
                        src={employeeData.profile_pic}
                        width="85px"
                        height="85px"
                        className="mx-4 mt-1"
                        style={{
                          border: "1px solid lightgrey ",
                          borderStyle: "dashed",
                          borderRadius: "8px",
                        }}
                      />
                    </Col>
                    <Col lg="8" className="mt-2 mx-2 ">
                      <h4>
                        <span className="text-success">
                          {employeeData.full_name}
                        </span>
                      </h4>
                      <h5 className="text-black m-0">
                        {employeeData.phone_number}
                      </h5>
                      <h5 className="text-black ">{employeeData.email}</h5>
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            ) : (
              <Col lg="4">
                <Card>
                  <CardBody
                    className="d-flex justify-content-center "
                    style={{ padding: "1.7rem", height: "150px" }}
                  >
                    <div
                      className="spinner-border align-self-center text-warning"
                      role="status"
                    >
                      <span className="sr-only"></span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}
            <Col lg="8">
              <Card
                // onClick={() => {
                //   navigate(`/user_management/${employeeData?.reporting_to.id}`);
                // }}
                style={{ cursor: "pointer" }}
              >
                <CardHeader className="d-flex justify-content-between m-0">
                  <div className="d-flex ">
                    {" "}
                    <Avatar
                      className="mt-1"
                      alt="Remy Sharp"
                      src={employeeData?.reporting_to?.profile_pic}
                      sx={{ width: 24, height: 24 }}
                    />
                    <span className="mx-2 mt-1">
                      {employeeData?.reporting_to?.full_name}
                    </span>
                  </div>

                  {RolesFromToken?.groups?.includes("admin") ||
                  RolesFromToken?.groups?.includes("HR") ? (
                    <Button
                      size="sm"
                      className="bg-primary border-0"
                      onClick={handleAddModel}
                    >
                      {employeeData?.reporting_to?.full_name ? "Edit" : "Add"}{" "}
                      {employeeData?.reporting_to?.full_name ? (
                        <span className="mdi mdi-account-edit fs-6"></span>
                      ) : (
                        <span className="mdi mdi-plus fs-6"></span>
                      )}
                    </Button>
                  ) : (
                    ""
                  )}
                </CardHeader>
                <Row style={{ padding: "0.8rem" }}>
                  <Col lg="3" className="">
                    <CustomTextField
                      name="full_name"
                      onChange={handleInputChange}
                      value={employeeData?.reporting_to?.full_name}
                      disabled={!addreporting}
                    />
                  </Col>
                  <Col lg="3" className="">
                    <CustomTextField
                      type="number"
                      name="phone_number"
                      onChange={handleInputChange}
                      value={employeeData?.reporting_to?.phone_number}
                      disabled={!addreporting}
                    />
                  </Col>
                  <Col lg="3" className="">
                    <CustomTextField
                      name="designation"
                      onChange={handleInputChange}
                      value={employeeData?.reporting_to?.designation}
                      disabled={!addreporting}
                    />
                  </Col>
                  <Col lg="3" className="">
                    <CustomTextField
                      name="employee_code"
                      onChange={handleInputChange}
                      value={employeeData?.reporting_to?.employee_code}
                      disabled={!addreporting}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        ) : (
          ""
        )}

        <Card style={{ shadow: "none" }}>
          <CardHeader className="mb-3 d-flex justify-content-between">
            <h5 className="mt-2">Basic Detail</h5>
            {!isCreateComponent ? (
              <Button
                size="sm"
                className={`${
                  isEditable ? "btn-danger" : "bg-primary border-0"
                } float-right fs-6`}
                onClick={() => handleEditButton(isEditable)}
              >
                {isEditable ? "Cancel" : "Edit"}{" "}
                {isEditable ? (
                  <span className="mdi mdi-close fs-6"></span>
                ) : (
                  <span className="mdi mdi-account-edit fs-6"></span>
                )}
              </Button>
            ) : (
              ""
            )}
          </CardHeader>
          <CardBody className="p-3 ">
            <Row className="">
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  label="First Name"
                  name="first_name"
                  placeholder="Enter first name"
                  onChange={handleInputChange}
                  value={employeeData.first_name}
                  disabled={!isEditable}
                />
              </Col>

              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  label="Last Name"
                  name="last_name"
                  placeholder="Enter last name"
                  onChange={handleInputChange}
                  value={employeeData.last_name}
                  disabled={!isEditable}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  maxlength="10"
                  label="Mobile No"
                  name="phone_number"
                  placeholder="123456789"
                  onChange={handleInputChange}
                  value={employeeData.phone_number}
                  disabled={!isEditable}
                  // disabled={phoneEnable == true ? true : false}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="email"
                  name="email"
                  placeholder="someone@example.com"
                  onChange={handleInputChange}
                  value={employeeData.email}
                  disabled={!isEditable}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="date"
                  name="DOB"
                  placeholder="25-02-2001"
                  onChange={handleInputChange}
                  defaultValue={employeeData?.DOB?.split("-")
                    .reverse()
                    .join("-")}
                  disabled={!isEditable}
                  style={{ padding: "12px" }}
                  className="rounded-1"
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  label="Department"
                  name="department"
                  placeholder={isEditable ? "Enter Department" : ""}
                  onChange={handleInputChange}
                  value={employeeData.department}
                  disabled={!isEditable}
                />
              </Col>

              {isEditable ? (
                <Col lg="3" className="mb-2">
                  <CustomTextField
                    label="Designation"
                    name="designation"
                    onChange={handleDesignation}
                    value={designation}
                  />
                </Col>
              ) : (
                <Col lg="3" className="mb-3">
                  <CustomTextField
                    label="Designation"
                    name="designation"
                    disabled
                    value={designation || employeeData.designation}
                  />
                </Col>
              )}

              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  label="Employee Code"
                  name="employee_code"
                  placeholder="Enter code"
                  required
                  onChange={handleInputChange}
                  value={employeeData.employee_code}
                  disabled={!isEditable}
                />
              </Col>

              {isEditable ? (
                <Col lg="3" className=" mb-2">
                  <label className="text-black mb-2">
                    Roles <span className="text-danger">*</span>
                  </label>

                  <Select
                    isMulti={true}
                    name="roles"
                    options={handleRolesOptions()}
                    onChange={handleRole}
                    styles={customStyles}
                    defaultValue={selectedRoles}
                  />
                </Col>
              ) : (
                <Col lg="3" className="mb-2">
                  <CustomTextField
                    label="Roles"
                    name="roles"
                    disabled
                    value={employeeData?.roles}
                  />
                </Col>
              )}
            </Row>
          </CardBody>
        </Card>

        <Card style={{ shadow: "none" }}>
          <CardHeader className="mb-3">
            <h5 className="mt-2">Operation Area</h5>
          </CardHeader>
          <CardBody className="p-3 ">
            {RoleAcessParams.includes("CBBO") ||
            roles.includes("CRM Admin") ||
            roles.includes("CRM User") ? (
              ""
            ) : (
              <Row>
                {isEditable && (!RoleAcessParams.includes("FPO") && !RoleAcessParams.includes("CBBO")) ? (
                  <Col lg="3" className="mb-2">
                    <label className="text-black mb-2">
                      Assigned Domain <span className="text-danger">*</span>
                    </label>
                    {RolesFromToken?.groups?.includes("Banking Admin")?
                    <CustomTextField
                      label=""
                      name=""
                      disabled
                      value="Banking"
                    />
                   :
                    <Select
                      isMulti
                      name="assigned_domains"
                      // options={selectedDomain?.length>0?availableDomains:DomainOptions}
                                            options={DomainOptions}
                                                                                        // options={...new set([...selectedDomain, ...availableDomains])}


                      defaultValue={selectedDomain}
                      placeholder={
                        domain ||
                        employeeData?.assigned_domains ||
                        "Select Domain"
                      }
                      onChange={handleDomain}
                      styles={customStyles}
                    />
                    }
                  </Col>
                ) : (
                  <Col lg="3">
                    <CustomTextField
                    label="Domains"
                     name="assigned_domains"
                     disabled
                     value={(employeeData?.assigned_domains || []).join(", ")}  
                        />         
                    </Col>
                )}

                {isEditable ? (
                  <Col lg="3" className="mb-2">
                    <label className="text-black mb-2">
                      Assigned Zone <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="assigned_zone"
                      options={ZoneOptions}
                      placeholder={zone || employeeData.assigned_zone}
                      value={
                        ZoneOptions.find((option) => option.label === zone) ||
                        undefined
                      }
                      onChange={handleZone}
                      styles={customStyles}
                    />
                  </Col>
                ) : (
                  <Col lg="3" className="mb-3">
                    <CustomTextField
                      label="assigned_zone"
                      name="assigned_zone"
                      disabled
                      value={employeeData.assigned_zone}
                    />
                  </Col>
                )}
                {isEditable ? (
                  <Col lg="3" className="mb-4 ">
                    <label className="text-black mb-2"> Selected {zone}</label>
                    <CustomTextField
                      name=""
                      disabled
                      value={selectedZones}
                      styles={customStyles}
                    />
                  </Col>
                ) : (
                  <Col
                    lg={
                      employeeData?.assigned_zone_code_names?.length > 2
                        ? "6"
                        : "3"
                    }
                    className="mb-4 "
                  >
                    <label className="text-black mb-2">
                      {" "}
                      Selected {employeeData.assigned_zone}
                    </label>
                    <CustomTextField
                      name=""
                      disabled
                      value={employeeData?.assigned_zone_code_names}
                      styles={customStyles}
                    />
                  </Col>
                )}

                <Row>
                  {["State", "District", "Block", "Sub-District"].includes(
                    zone
                  ) &&
                    isEditable && (
                      <Col lg="3" className="mb-4">
                        <label className="text-black mb-2">State</label>
                        <Select
                          isMulti={zone === "State"}
                          options={handleStateOptions()}
                          onChange={onLocationChange}
                          placeholder={
                            stateId === "" ? "Select State" : stateName
                          }
                          styles={customStyles}
                        />
                      </Col>
                    )}

                  {["District", "Block", "Sub-District"].includes(zone) &&
                    isEditable && (
                      <Col lg="3" className="mb-4 ">
                        <label className="text-black mb-2"> District</label>
                        <Select
                          isMulti={zone === "District" ? true : false}
                          menuPlacement="auto"
                          options={handleDistrictOptions()}
                          onChange={onDistrictChange}
                          isOptionDisabled={() =>
                            RolesFromToken?.groups?.includes("admin")
                              ? false
                              : selectedZones.length >= 3
                          }
                          placeholder={
                            districtId == "" ? "Select District" : districtName
                          }
                          styles={customStyles}
                        />
                      </Col>
                    )}
                  {zone === "Sub-District" || zone === "Block" ? (
                    <Col lg="3" className="mb-4 ">
                      <label className="text-black mb-2">Sub-District</label>
                      <Select
                        isMulti={zone === "Sub-District" ? true : false}
                        menuPlacement="auto"
                        options={handleSubDistrictOptions()}
                        onChange={onSubDistrictChange}
                        isOptionDisabled={() =>
                          RolesFromToken?.groups?.includes("admin")
                            ? false
                            : selectedZones.length >= 3
                        }
                        placeholder={
                          subDistrictId == ""
                            ? "Select Sub-District"
                            : subDistrictName
                        }
                        styles={customStyles}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                  {zone === "Block" ? (
                    <Col lg="3" className="mb-4 ">
                      <label className="text-black mb-2"> Block</label>
                      <Select
                        isMulti={zone === "Block" ? true : false}
                        menuPlacement="auto"
                        options={handleBlockOptions()}
                        onChange={onBlockChange}
                        placeholder={blockId == "" ? "Select Block" : blockName}
                        isOptionDisabled={() =>
                          RolesFromToken?.groups?.includes("admin")
                            ? false
                            : selectedZones.length >= 3
                        }
                        // value={blockId === "" ? "Select Block" : blockName}
                        className="SelectAgentClass text-black"
                        styles={customStyles}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </Row>
            )}
          </CardBody>
        </Card>

        {RoleAcessParams?.includes("admin") && (
          <Card style={{ shadow: "none" }}>
            <CardHeader className="mb-3  d-flex justify-content-between w-100">
              <h5 className="mt-2">Projects</h5>

              <Button
                size="sm"
                className="bg-primary border-0"
                onClick={handleAddProjects}
              >
                {" "}
                Add New <PlusCircleFilled />
              </Button>
            </CardHeader>
            <CardBody className="p-3 ">
              {RoleAcessParams.includes("admin") && (
                <Row>
                  <div className="">
                    {Array.isArray(assignedProjects) &&
                    assignedProjects.length > 0 ? (
                      <div className="row ">
                        {assignedProjects.map((project, index) => (
                          <div
                            className=" col-lg-4 col-12 col-md-4"
                            key={project.id || index}
                          >
                            <Card style={{ backgroundColor: "#f9ba6b0a" }}>
                              <IconButton
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  color: "gray",
                                  zIndex: 10,
                                }}
                                onClick={(e) => handleMenuClick(e, project)}
                              >
                                <MoreVert
                                  sx={{ color: "gray", fontSize: "18px" }}
                                />
                              </IconButton>
                              <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                                PaperProps={{
                                  elevation: 0,
                                  sx: {
                                    boxShadow:
                                      "0px 2px 8px rgba(0, 0, 0, 0.05)",
                                    borderRadius: "4px",
                                  },
                                }}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                              >
                                <MenuItem
                                  onClick={handleEditProject}
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Edit
                                    className="text-primary"
                                    sx={{
                                      marginRight: "5px",
                                      fontSize: "16px",
                                    }}
                                  />
                                  Edit
                                </MenuItem>
                                <MenuItem
                                  onClick={() => handleDeleteClick(project.id)}
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Delete
                                    className="text-danger"
                                    sx={{
                                      marginRight: "5px",
                                      fontSize: "16px",
                                    }}
                                  />
                                  Delete
                                </MenuItem>
                              </Menu>

                              <CardContent>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                  mb={1}
                                >
                                  <Assignment
                                    fontSize="small"
                                    sx={{ color: "orange" }}
                                  />
                                  <Typography
                                    variant="h5"
                                    sx={{ fontWeight: 600 }}
                                    className="text-black"
                                  >
                                    {project.name || "Unnamed Project"}
                                  </Typography>
                                </Stack>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                  mb={1}
                                >
                                  <span className="mdi mdi-map-marker text-sm text-orange"></span>
                                  <h6 className="text-black">
                                    Assigned Zone :-{" "}
                                  </h6>
                                  <Typography
                                    variant="h5"
                                    sx={{ fontWeight: 600 }}
                                    className="text-black text-capitalize"
                                  >
                                    {project?.assigned_zone}
                                  </Typography>
                                </Stack>

                                <Box mt={1}>
                                  <Typography
                                    variant="h6"
                                    color="text.secondary"
                                  >
                                    📍 Zone
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    <ArrowRight sx={{ fontSize: "16px" }} />{" "}
                                    {project.assigned_zone_names?.join(", ") ||
                                      "N/A"}
                                  </Typography>
                                </Box>
                              </CardContent>
                            </Card>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <Typography>No assigned projects found.</Typography>
                    )}

                    {/* Confirmation Dialog */}
                    <Dialog
                      open={opendeleteModal}
                      onClose={() => setOpenDeleteModal(false)}
                    >
                      <DialogTitle>Delete Project</DialogTitle>
                      <DialogContent>
                        <Typography>
                          Are you sure you want to delete this project?
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={() => setOpenDeleteModal(false)}
                          color="primary"
                          size="sm"
                        >
                          Cancel
                        </Button>
                        <Button onClick={handleDelete} color="danger" size="sm">
                          Delete
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </Row>
              )}
            </CardBody>
          </Card>
        )}

        <Button
          className={`btn btn-success p-2 fs-6 me-2 px-3  mb-2`}
          style={{ float: "right" }}
          onClick={handleSubmitButton}
        >
          <Save fontSize="10" className="mb-1" /> Submit &nbsp;
          {submitDisableButton ? (
            <Spinner animation="border" size="sm" className="text-center" />
          ) : (
            ""
          )}
        </Button>

        <Modal show={addModel} onHide={handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "" }} className="fw-bold">
              Add/Edit Reporting Manager
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <ReportingtoId id={emp_id} handleClose={handleClose} />
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        <Modal show={ProfileModel} onHide={handleClose} size="md">
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "" }} className="fw-bold">
              {activeValue ? "Disable User" : "Enable User"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="">
            <div className="">
              <h4 className="text-gray text-center mt-3">
                Are you Sure to Want to {activeValue ? "Disable " : "Enable "}{" "}
                <strong className="text-black">{employeeData.full_name}</strong>{" "}
                ?
              </h4>
            </div>
            <div className="">
              {" "}
              <p className="text-gray text-italic text-bottom  mt-4 mb-0">
                <strong>Note : </strong>
                {activeValue
                  ? "Users will not be able to login or perform any actions if they are disabled."
                  : "Enabled uses can login and perform actions based on the assigned roles"}
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-danger waves-effect me-2"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="btn btn-success waves-effect me-2"
              onClick={handleEnabledButton}
            >
              {activeValue ? "Disable " : "Enable"}
            </button>
          </Modal.Footer>
        </Modal>
      </div>

      {/* Add Project Modal  */}

      <Modal show={addProject} onHide={handleCloseProjectModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Add Project</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1.5rem", backgroundColor: "#f5f7fa" }}>
          <AddProjectModal
            employeeDataRefetch={employeeDataRefetch}
            employeeData={employeeData}
            addProjectModel={setAddProject}
          />
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#f5f7fa" }}></Modal.Footer>
      </Modal>

      {/* Edit Project Modal  */}
      <Modal
        show={editProjectModal}
        onHide={() => setEditProjectModal(false)}
        size="l"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Edit Project</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1.5rem", backgroundColor: "#f5f7fa" }}>
          <EditProject
            selectedProject={selectedProject}
            employeeDataRefetch={employeeDataRefetch}
            employeeData={employeeData}
            setEditProjectModal={setEditProjectModal}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default AddEmployee;
